var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #04be76;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4072",
    "data-name": "Group 4072",
    transform: "translate(5643 9093)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3579",
    "data-name": "Group 3579",
    transform: "translate(-5643 -9090)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6892",
    "data-name": "Path 6892",
    className: "cls-1",
    d: "M19.864,100.911V90.329a.126.126,0,0,0-.129-.129H16.709a.126.126,0,0,0-.129.129v10.583H15.051v-7.36a.126.126,0,0,0-.129-.129H11.9a.126.126,0,0,0-.129.129v7.36H10.233V89.629A.126.126,0,0,0,10.1,89.5H7.078a.126.126,0,0,0-.129.129v11.282H5.42V95.546a.126.126,0,0,0-.129-.129H2.265a.126.126,0,0,0-.129.129v5.365H0v1.05H22v-1.05Z",
    transform: "translate(0 -83.975)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6893",
    "data-name": "Path 6893",
    className: "cls-1",
    d: "M33.9,9.7a1.807,1.807,0,0,0,1.5-2.805l2.633-3.419a1.8,1.8,0,0,0,1.59-.11l2.259,2.185a1.773,1.773,0,0,0-.16.743,1.8,1.8,0,1,0,3.609,0,1.739,1.739,0,0,0-.092-.571l2.21-1.768a1.776,1.776,0,1,0-.608-.755L44.7,4.917a1.8,1.8,0,0,0-2.191-.11l-2.2-2.13A1.806,1.806,0,1,0,36.919,1.8a1.823,1.823,0,0,0,.356,1.08l-2.6,3.376a1.78,1.78,0,0,0-.767-.172,1.8,1.8,0,0,0,0,3.609Z",
    transform: "translate(-30.13 -2)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1139",
    "data-name": "Rectangle 1139",
    className: "cls-2",
    width: 22,
    height: 22,
    transform: "translate(-5643 -9093)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardActive);
export default __webpack_public_path__ + "static/media/dashboard_active.5d758609f8906e0264396b2dc8b097a8.svg";
export { ForwardRef as ReactComponent };